module.exports = __webpack_public_path__ + "static/media/SpiderDeath.6377ed50.mp3";